export const REQUESTS_RECEIVED = "REQUESTS_RECEIVED";
export const REQUESTS_CREATED = "REQUESTS_CREATED";
export const REQUESTS_UPDATED = "REQUESTS_UPDATED";
export const REQUESTS_DELETED = "REQUESTS_DELETED";
export const REQUESTS_EMAIL_SENT = 'REQUESTS_EMAIL_SENT';